export type TrainingCreditCosts = {
  interview: number;
  dialog: number;
  customsCheck: number;
};

export const useTrainingCreditCosts = () => {
  const costs = useState<TrainingCreditCosts | null>("training-credit-costs", () => null);
  const loading = useState("training-credit-costs-loading", () => false);
  const apiFetch = useApiFetch();

  const load = async () => {
    if (costs.value || loading.value) {
      return;
    }
    loading.value = true;
    try {
      costs.value = await apiFetch<TrainingCreditCosts>("/quota/training-costs");
    } catch {
      costs.value = null;
    } finally {
      loading.value = false;
    }
  };

  return {
    costs: readonly(costs),
    loading: readonly(loading),
    load,
  };
};
